import React from "react"
import FormLayout from "common/components/templates/FormLayout"
import Title from "common/components/atoms/Title"
import Text from "common/components/atoms/Text"
import { useTranslation } from "react-i18next"

const PasswordSentEn = () => {
  const { t } = useTranslation()

  return (
    <FormLayout>
      <Title order={5} color="purple" fw="bold">
        {"Email has been sent"}
      </Title>
      <Text ta="center" fw="bold">
        We sent a link to reset your password.
      </Text>
    </FormLayout>
  )
}

export default PasswordSentEn
